export const catalog_matrix = [
    {form_key:'responsible_id', catalog_key:'none', propname:'users'},
    {form_key:'diot_responsible_id', catalog_key:'none', propname:'users'},
    {form_key:'process_status_id', catalog_key:'process_statuses'},
    {form_key:'compliance_opinion_status_id', catalog_key:'compliance_opinion_statuses'},
    {form_key:'mailbox_status_id', catalog_key:'mailbox_statuses'}
]